// src/pages/Dashboard.jsx - Modüler yapı
import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import './Dashboard.css';

// Modüler importlar
import { useDashboard, useTemplateCategories } from './hooks/useDashboard';
import WelcomeCard from './components/WelcomeCard';
import StatsSection from './components/StatsSection';
import TemplatesSection from './components/TemplatesSection';
import AnalyticsSection from './components/AnalyticsSection';
import SharingStatsSection from './components/SharingStatsSection';
import TipsSection from './components/TipsSection';
import RecentFormsSection from './components/RecentFormsSection';



const Dashboard = () => {
  const { t } = useTranslation();
  
  // Hooks
  const {
    loading,
    statsData,
    isFormUserLoggedIn,
    forms,
    userData,
    fetchFormData
  } = useDashboard();

  const {
    activeCategory,
    setActiveCategory
  } = useTemplateCategories();

  return (
    <Box className="dashboard-container">
      {/* Hoş Geldin Kartı */}
      <WelcomeCard userData={userData} />

      {/* İstatistik Kartları */}
      <StatsSection 
        statsData={statsData}
        loading={loading}
        onRefresh={fetchFormData}
      />

      {/* Form Şablonları */}
      <TemplatesSection 
        activeCategory={activeCategory}
        onCategoryChange={setActiveCategory}
      />

      {/* Form Analitikleri */}
      <AnalyticsSection />

      {/* Paylaşım İstatistikleri */}
      <SharingStatsSection />

      {/* İpuçları ve Eğitimler */}
      <TipsSection />

      {/* Son Eklenen Formlar */}
      <RecentFormsSection forms={forms} />
    </Box>
  );
};

export default Dashboard;